@charset "UTF-8";

/* src/app/feedback-question/feedback-question.component.scss */
.mat-column-template_key {
  max-width: 340px;
  width: 340px;
  flex: 0 0 340px;
}
.mat-cell {
  text-align: left;
  padding: 0px 3px;
}
.mat-column-id {
  max-width: 50px;
  padding-left: 0px;
}
.mat-column-likert {
  max-width: 50px;
}
.template-key-label {
  cursor: pointer;
  text-decoration: underline dotted;
}
.statement {
  display: block;
}
.statement::before {
  content: "\21aa";
  margin-right: 5px;
}
/*# sourceMappingURL=feedback-question.component.css.map */
